export enum TutoringType {
  atTeacher = '1',
  atStudent = '2',
  online = '3',
}

export type TutoringTypeUnion = '1' | '2' | '3';
